{
    "TITLE" : "Remote 應用",
        "SHARED": {
            "INTERNET_OFFLINE": "您的網絡連接似乎處於離線狀態。",
            "LANGUAGE": "語言",
            "NO_FEATURE": "您的授權不包含此功能。 請聯繫您的管理員。",
            "FEATURE_UNAVAILABLE": "您的授權不包含此功能。",
            "APP_UPDATE_NEEDED": "To use this feature, this participant needs to update their app.",
            "TRAINING_DISABLED": "您沒有權限使用此功能。 請向主持人申請許可。"
        },
        "UPDATE_MODAL": {
            "TITLE": "有可用的更新",
            "MESSAGE": "有新版本可用。 此頁面將在更新後重新加載。",
            "UPDATE": "重新加載",
            "UPDATE_FAILED": "更新失敗"
        },
        "LOGIN" : {
        "SSO-BUTTON": "使用 SSO 登入",
            "APP_NAME": "{{ appName }} Remote",
            "TITLE": "登入 Remote 應用",
            "ACCOUNT_PLACEHOLDER" : "帳戶名稱",
            "ACCOUNT_REQUIRED" : "帳戶名稱是必需的。",
            "ACCOUNT_SHORT" : "帳戶名稱必須至少為 2 個字符。",
            "USERNAME_PLACEHOLDER" : "用戶名稱",
            "USERNAME_REQUIRED" : "用戶名稱是必需的。",
            "USERNAME_SHORT" : "用戶名稱必須至少為 2 個字符。",
            "PASSWORD_PLACEHOLDER" : "密碼",
            "PASSWORD_REQUIRED" : "密碼是必需的。",
            "PASSWORD_SHORT" : "密碼必須至少6個字符。",
            "REMEMBER_ACCOUNT_NAME": "記住賬戶名稱",
            "VERIFICATION_CODE": "驗證碼",
            "TWO_FACTOR_EMAIL_SENDED": "我們已向您發送了一封包含驗證碼的電子郵件。",
            "VERIFY_BUTTON": "確認",
            "LOGIN_BUTTON" : "登入",
            "BACK_BUTTON" : "日耳曼",
            "BEFORE_TERMS": "點擊登入，即表示您同意我們的",
            "TERMS": "服務條款",
            "CONJUNCTION": "和",
            "PRIVACY": "隱私政策",
            "AFTER_PRIVACY": "。",
            "GUEST_DELETED": "您已登出。",
            "USER_DELETED": "您的帳戶已被刪除。 請聯繫您的管理員。",
            "USER_DISABLED": "您的帳戶已被禁用。 請聯繫您的管理員。",
            "LOGGED_IN_ANOTHER_SESSION": "您已登錄另一個會議。",
            "LOGGED_OUT_UNKNOWN": "哎呀！出事了.",
            "NO_INTERNET_ERROR": "連接中斷。 請檢查您的網絡連接。",
            "USERNAME_PASSWORD_ERROR" : "帳戶名稱、用戶名稱或密碼錯誤。",
            "ACCOUNT_DISABLED": "您的帳戶已過期。 請聯繫 {{ contactMail }}",
            "INVALID_VERIFICATION_CODE" : "兩步驗證碼無效。",
            "UNKNOWN_ERROR" : "登錄時發生錯誤。",
            "SIMULTANE_LOGIN_ERROR": "您已登錄另一個會議。",
            "USE_CHINA_SERVERS": "我從中國登錄",
            "CHINA_SERVERS_CAUTION": "此選項可能會導致中國大陸以外的延遲。",
            "MULTI_LOGIN_MODAL": {
                "TITLE": "多重登錄",
                "MESSAGE": "您的用戶已在另一台設備上登錄。 如果您繼續，其他設備將被登出。",
                "CANCEL": "取消",
                "PROCEED": "繼續"
            }
        },
        "MAIN" : {
            "LICENSE_LEFT": "您的 {{ appName }} Remote 許可證還剩 {{ days }} 天。",
            "DEMO_LEFT": "您的 {{ appName }} Remote 試用期還剩 {{ days }} 天。",
            "LEFT_BAR": {
                "LOBBY": "大堂",
                "ROOMS": "專室",
                "MEETINGS": "會議",
                "FEEDBACK": "反饋",
                "CONTACTS": "用戶",
                "SESSIONS": "會話",
                "TICKETS": "工單",
                "PRECALL_TEST": "預通話測試",
                "WHATS_NEW": "什麼是新的",
                "PROFILE": "簡介",
                "HELP_CENTER": "服務台",
                "LOGOUT": "登出"
            },
            "CALL_MESSAGE": {
                "TITLE":"來電來自 <strong>{{ caller_name }}</strong>",
                "DENY": "拒絕",
                "ACCEPT": "接受"
            },
            "GET_EXPORT_MODAL": {
                "TITLE": "獲取會議導出",
                "MESSAGE1": "請輸入您的電子郵件地址以在會議結束後接收會議導出下載鏈接。",
                "MESSAGE2": "會議導出將包括會議中共享的所有聊天消息、快照、視頻通話記錄和文件。",
                "EXPORT_NAME_NOT_LOCKED": "您可以通過輸入自定義文件名來重命名導出文件。",
                "EXPORT_NAME_LOCKED": "其他用戶完成導出後，您將能夠重命名導出文件。",
                "EXPORT_NAME_RENAMED": "導出文件被此用戶重命名：",
                "EXPORT_NAME_PLACEHOLDER": "出口名稱",
                "NOTE": "注意：您可以從配置文件菜單更新您的電子郵件地址。",
                "NOTE2": "注意：您可以通過管理員更新您的電子郵件地址。",
                "OPEN_PROFILE": "打開個人資料",
                "EMAIL": "電子郵件",
                "EMAIL_REQUIRED": "電子郵件是必需的。",
                "EMAIL_INVALID": "電子郵件格式無效。",
                "CLOSE": "關閉",
                "SEND": "發送",
                "EXPORT_SUCCEEDED": "會議導出將在會議結束後發送。",
                "ENDED_SESSION_EXPORT_SUCCEEDED": "會話導出已發送。",
                "EXPORT_FAILED": "發生錯誤。"
            },
            "EASY-ACCESS": {
                "MANAGE-PUBLIC-ACCESS": "管理公共訪問",
                "MANAGE-PUBLIC-ACCESS-TEXT": "您可以通過刪除公共訪問來停止共享此工作流程。",
                "GENEATE-ACCESS-TEXT": "您可以生成公共連結和QR碼來為此工作流程創建便捷訪問。",
                "ENABLE-PASSWORD": "啟用密碼",
                "GENERATE-ACCESS": "生成",
                "LINK": "連結",
                "COPY": "複製",
                "QR-CODE": "QR碼",
                "DOWNLOAD": "下載",
                "SECURITY": "安全",
                "PASSWORD-PROTECTED": "密碼保護",
                "PUBLIC": "公開",
                "DELETE-ACCESS": "刪除公共訪問",
                "EASY-ACCESS-TITLE": "{{ shortName }} 工作流程便捷訪問",
                "OPEN-WORKFLOW-NAME": "您即將打開",
                "GUEST-EMAIL": "訪客電子郵件",
                "REQUIRED": "此欄位為必填項",
                "GUEST-PASSWORD": "訪客密碼",
                "OPEN": "打開",
                "OPEN-APP": "我們建議在我們的應用程式中打開此工作流程以獲得更好的體驗。",
                "COPY-LINK-TEXT": "將連結複製到剪貼板，以便在應用程式啟動時打開此工作流程。",
                "DOWNLOAD-APP": "下載應用程式",
                "DOWNLOAD-SMARTGLASSES-APP": "下載智能眼鏡應用程式",
                "OR": "或",
                "CONTINUE-WITH-BROWSER": "在瀏覽器中繼續",
                "PASSWORD-PROTECTED-TEXT": "啟用密碼後，擁有公共連結或QR碼的用戶只有在輸入密碼後才能訪問此工作流程。",
                "CREATE-PASSWORD": "創建密碼",
                "ENTER-EMAIL": "輸入您的電子郵件",
                "ENTER-WORKFLOW-PASSWORD": "輸入工作流程密碼",
                "DELETE-QR-TEXT": "要更改便捷訪問的安全類型，您應該刪除便捷訪問並重新生成。",
                "LOADING-WORKFLOW": "正在加載工作流程...",
                "UNABLE-TO-LOAD": "無法加載工作流程",
                "RETRY": "重試",
                "GUEST-ACCESS": {
                    "TOKEN-MISSING": "令牌缺失或無效",
                    "ID-MISSING": "工作流程ID或基礎URL缺失",
                    "WORKFLOW-NOT-PUBLISHED": "工作流程未發布",
                    "PUBLIC-ACCESS": "公共訪問已存在",
                    "NO-PUBLIC-ACCESS": "無公共訪問"
                },
                "QR-INFORMATION": "QR資訊"
            },
            "VIDEO-FLOW-DASHBOARD": {
                "TITLE": "視頻流程",
                "CREATE-VIDEO-FLOW": "創建視頻流程",
                "CREATED-BY-AI": "由人工智慧創建",
                "VERSION": "版本",
                "NO-VIDEO-FLOWS-FOUND": "未找到視頻流程",
                "CLEAR-ALL": "清除全部",
                "CONFIRM-VIDEO": "確認視頻",
                "CONFIRM-VIDEO-TITLE": "確認視頻轉換",
                "CONFIRM-VIDEO-MESSAGE": "您確定要將此視頻流程轉換為工作流程嗎？確認後，您將無法編輯視頻。",
                "CONFIRM-VIDEO-BUTTON": "確認並轉換",
                "MAKE-WORKFLOW-SUCCESSFUL": "成功轉換為工作流程",
                "MAKE-WORKFLOW-ERROR": "轉換為工作流程失敗",
                "UPLOAD-VIDEO-DESCRIPTION": "上傳您的視頻以自動生成分步工作流程指南。",
                "VIDEO-DURATION-LIMIT": "視頻時長不能超過30分鐘。",
                "VIDEO-UPLOADED-SUCCESS": "視頻上傳成功！",
                "SELECT-VIDEO": "選擇視頻",
                "CHANGE-VIDEO": "更改視頻",
                "CREATE-BUTTON": "創建",
                "AI-PROCESSING": "AI處理中",
                "SPLITTING-VIDEO": "將視頻分割成片段",
                "TRANSCRIBING-VIDEO": "轉錄視頻內容",
                "PROCESS-WARNING": "此過程可能需要10分鐘。請不要關閉此視窗。"
            },
            "NAVBAR" : {
                "PRECALL_TEST": "預通話測試",
                "PRECALL_END_SESSION": "請在預通話測試前結束會議。",
                "LOGOUT" : "登出",
                "LANGUAGE" : "語言",
                "LOGOUT_MODAL_TITLE": "登出？",
                "LOGOUT_MODAL_MESSAGE": "這將使您登出。",
                "CAUTION": "注意：這會在不結束會話的情況下將您註銷。會話後的彈出窗口和其他信息可能會丟失（例如會話導出）！",
                "LOGOUT_MODAL_MESSAGE_IN_ROOM": "您將離開會話並註銷。",
                "LOGOUT_MODAL_NO": "取消",
                "LOGOUT_MODAL_YES": "登出",
                "LOGOUT_FAILED": "登出時發生錯誤",
                "HELP_CENTER": "服務台",
                "PROFILE_TITLE": "簡介",
                "PROFILE_NAME": "名稱",
                "PROFILE_EMAIL": "電子郵件",
                "PROFILE_PASSWORD": "密碼",
                "PROFILE_CHANGE_LINK": "更改",
                "PROFILE_ADD_LINK": "添加",
                "PROFILE_CLOSE": "關閉",
                "CHANGE_PASS_TITLE": "更改密碼",
                "CHANGE_PASS_OLD_PASS": "舊密碼",
                "CHANGE_PASS_NEW_PASS": "新密碼",
                "CHANGE_PASS_RPT_PASS": "確認密碼",
                "CHANGE_PASS_REQUIRED": "密碼是必需的。",
                "CHANGE_PASS_NOT_MATCH": "密碼不匹配",
                "CHANGE_PASS_CLOSE_BTN": "關閉",
                "CHANGE_PASS_CHANGE_BTN": "更改密碼",
                "CHANGE_PASS_SUCCESS": "您的密碼已更改。",
                "CHANGE_PASS_WRONG": "您的密碼錯誤。",
                "CHANGE_PASS_FAILED": "密碼更改失敗。",
                "CHANGE_EMAIL_TITLE": "更改電子郵件",
                "CHANGE_EMAIL_NEW_EMAIL": "新郵件",
                "CHANGE_EMAIL_RPT_EMAIL": "確認電子郵件",
                "CHANGE_EMAIL_REQUIRED": "電子郵件為必填項.",
                "CHANGE_EMAIL_NOT_VALID": "電子郵件無效.",
                "CHANGE_EMAIL_NOT_MATCH": "電子郵件地址不匹配.",
                "CHANGE_EMAIL_CLOSE_BTN": "關閉",
                "CHANGE_EMAIL_CHANGE_BTN": "更改電子郵件",
                "CHANGE_EMAIL_SUCCESS": "您的電子郵件已更改.",
                "CHANGE_EMAIL_FAILED": "電子郵件更改失敗.",
                "FEEDBACK": "Feedback",
                "SUCCESS_MESSAGE": "感謝您提交表格。我們的團隊會盡快回复您。",
                "CLOSE": "關閉",
                "CREATE_NEW_PASS": "密碼要求",
                "UPPERCASE": "大寫",
                "LOWERCASE": "小寫",
                "NUMBER": "數字",
                "SPECIAL": "特別的",
                "AT_LEAST_PASSWORD_LENGTH": "至少 {{ passwordlength }} 個字符",
                "OLD_PASSWORD": "舊密碼",
                "NOT_WHITESPACE": "您的密碼不得包含空格字符",
                "DO_NOT_CREATE_SIMPLE": "不要創建像“123456”這樣的弱密碼",
                "STATUS": {
                    "AVAILABLE": "可用的",
                    "BUSY": "忙碌的",
                    "APPEAR_OFFLINE": "顯示為離線"
                }
            },
            "LOBBY" : {
                "LOBBY_SHARED": {
                    "ONGOING_CALLS_TITLE": "正在進行的通話",
                    "ROOMS_TITLE": "您的專室",
                    "UPCOMING_MEETINGS_TITLE" : "即將召開的會議",
                    "PREVIOUS_MEETINGS_TITLE" : "以前的會議",
                    "SCHEDULE_MEETING": "安排會議",
                    "INSTANT_GUEST_ACCESS": "即時訪客訪問",
                    "INSTANT_GUEST_ACCESS_NO_CALLING": "您沒有撥打電話的權限。請聯繫管理員。",
                    "INSTANT_GUEST_ACCESS_NO_GUEST_ACCESS": "您沒有建立訪客訪問連結的權限。請聯繫管理員。",
                    "INSTANT_GUEST_ACCESS_NO_PERM": "您沒有撥打電話或建立訪客訪問連結的權限。請聯繫管理員。",
                    "LINK_UNAVAILABLE": "連結不可用",
                    "JOIN" : "加入",
                    "CANCEL": "取消",
                    "REMOVE": "去掉",
                    "NO_ROOM": "你沒有任何專室。",
                    "NO_MEETING": "你沒有任何會議。",
                    "NO_PREV_MEETING": "你沒有任何會議。",
                    "NO_OTHER_USERS": "沒有其他用戶。",
                    "SHOW_MORE": "顯示 {{ count }} 多",
                    "SHOW_LESS": "顯示較少"
                },
                "SCHEDULE_MEETING_MODAL": {
                    "TITLE": "安排會議",
                    "MEETING_TITLE": "標題*",
                    "MEETING_TITLE_REQUIRED": "標題必填。",
                    "START_DATE": "開始",
                    "END_DATE": "結尾",
                    "CLOSE": "關閉",
                    "SCHEDULE_SEND": "安排和發送",
                    "SCHEDULE": "日程",
                    "CANNOT_SCHEDULE": "安排會議時出錯。",
                    "CANNOT_CANCEL_MEETING": "取消會議時出錯。",
                    "ENTER_USERS": "輸入用戶",
                    "SEND_INVITATIONS": "發送邀請",
                    "INVITATION_EMAIL_LANG": "邀請郵件語言",
                    "SHARE_AFTER": "會議鏈接也可以在安排後共享。"
                },
                "CANCEL_MEETING_MODAL": {
                    "CANCEL_TITLE": "取消會議",
                    "REMOVE_TITLE": "刪除會議",
                    "CANCEL_MESSAGE": "您確定要取消會議嗎？",
                    "REMOVE_MESSAGE": "確定要刪除會議嗎？",
                    "CLOSE": "關閉",
                    "PROCEED": "繼續"
                },
                "CONTACTS": {
                    "TITLE": "用戶",
                    "NO_PERMISSION": "您沒有權限查看聯繫人和通話。",
                    "NO_CONTACT": "用戶列表為空。",
                    "SELECT_MULTI": "選擇多個",
                    "CALL": "通話",
                    "ADMIN": "管理員",
                    "COADMIN": "共同管理員",
                    "EXPERT": "專家",
                    "SUBSCRIBER": "訂戶",
                    "USER": "用戶",
                    "NAME": "名稱",
                    "USERNAME": "用戶名稱",
                    "ROLE": "角色",
                    "NO_EXPERT": "請至少選擇一位專家進行通話。",
                    "NAME_USERNAME": "姓名或用戶名",
                    "ALL_ROLES": "所有角色"
                },
                "SESSIONS": {
                    "TITLE": "會話",
                    "DATE": "创建於",
                    "DURATION": "总持续时间",
                    "ROOM_NAME": "专室",
                    "NO_SESSIONS": "會話列表為空。",
                    "PARTICIPANTS": "参与者",
                    "EXPORT": "出口",
                    "STATUS": "狀態",
                    "ON_GOING": "進行中",
                    "ENDED": "結束",
                    "FILES": "文件",
                    "CHAT": "聊天",
                    "SESSION_FILES": {
                        "MULTIPLE_SELECTION": "選擇多個",
                        "DOWNLOAD": "下载",
                        "DOWNLOAD_STARTED_SOON": "下载将很快开始。",
                        "DOWNLOAD_FAILED": "下载失败。",
                        "NO_FILE_IS_ADDED": "在此會話中未添加或協作任何文件。",
                        "SUCCESS_MESSAGE": "文件已成功下載。"
                    },
                    "ATTACHED_TICKET": "附票",
                    "SESSION_DETAILS": "會話詳細信息",
                    "BACK": "後退",
                    "GET_SESSION_EXPORT": "獲取會話導出",
                    "ATTACH_TO_TICKET": "附加到票證"
                },
                "TICKETS": {
                    "TITLE": "工單",
                    "NEW_TICKET": "新工單",
                    "ALL_ROOMS": "所有專室",
                    "ALL_STATUSES": "所有狀態",
                    "NO_TICKETS": "工單列表為空。",
                    "TICKET_TITLE": "標題",
                    "ROOM": "專室",
                    "CREATED_BY": "創建者",
                    "CREATED_ON": "創建於",
                    "STATUS": "狀態",
                    "STATUS_OPEN": "開放",
                    "STATUS_IN_PROGRESS": "進行中",
                    "STATUS_CLOSED": "關閉",
                    "CLOSE_PICK_TICKET": "關閉",
                    "CREATE_NEW": "創建新的",
                    "ATTACH": "附上",
                    "CREATE_TICKET": "創建工單",
                    "TICKET_DETAILS": "工單詳情",
                    "EDIT": "編輯",
                    "TICKET_TYPE": "工單類型",
                    "ROOM2": "專室： ",
                    "CREATED_BY2": "創建者： ",
                    "CREATED_ON2": "創建於： ",
                    "ROOM3": "專室",
                    "STATUS2": "狀態",
                    "PRIORITY": "優先",
                    "ASSIGNEE": "代理人",
                    "FOLLOW_UP": "跟進日期",
                    "TICKET_TITLE2": "標題",
                    "TITLE_REQUIRED": "標題為必填項",
                    "DESCRIPTION": "描述",
                    "DESCRIPTION_REQUIRED": "描述為必填項",
                    "RESOLUTION": "決議",
                    "ATTACHED_SESSIONS": "附加會議",
                    "NO_ATTACHED_SESSIONS": "附加會議列表為空",
                    "SESSION_COUNT": "會議次數： ",
                    "TOTAL_DURATION": "總持續時間： ",
                    "PARTICIPANTS2": "參與者：",
                    "COUNT_SESSIONS": " {{count}} 會議",
                    "DATE": "日期",
                    "ROOM_NAME": "專室名稱",
                    "PARTICIPANTS": "參與者：",
                    "DURATION": "持續時間",
                    "GUEST": "（來賓）",
                    "CANCEL": "取消",
                    "CLOSE": "關閉",
                    "SAVE": "保存",
                    "CREATE": "創建",
                    "CREATED_BETWEEN": "創建於",
                    "ALL_CREATORS": "所有創作者",
                    "SEND_VIA_EMAIL": "通過電子郵件發送",
                    "DELETE_TICKET": "刪除票",
                    "DELETE_TICKET_MODAL": {
                        "TITLE": "刪除工單？",
                        "MESSAGE":"您確定要刪除工單 <strong>{{title}}</strong> 嗎？",
                        "CANCEL": "取消",
                        "DELETE": "刪除"
                    },
                    "LOW": "低的",
                    "MEDIUM": "中等的",
                    "HIGH": "高的",
                    "CHOOSE_TICKET": "選擇門票",
                    "ERRORS": {
                        "TICKET_ALREADY_ATTACHED": "門票已附上。",
                        "ERROR_OCCURED": "發生錯誤。",
                        "PERMISSION_DENIED": "沒有權限。",
                        "MISSING_PARAMETERS": "缺少參數",
                        "FILE_ALREADY_EXIST": "文件已存在"
                    },
                    "FILES": "文件",
                    "UPLOAD_FILE": "上傳文件"
                },
                "ARCHIVES": {
                    "ARCHIVE_LIST": {
                        "LOADING": "加载中",
                        "CREATED_AT": "创建於",
                        "SIZE": "大小",
                        "STATUS": "状态",
                        "DOWNLOAD": "下载",
                        "AVAILABLE": "可用",
                        "DISCONNECTED": "已中断",
                        "DELETED": "已删除",
                        "EXPIRED": "已到期",
                        "WAITING": "等待中",
                        "FAILED": "已失败",
                        "REFRESH": "刷新",
                        "NO_ARCHIVE_MESSAGE": "沒有視頻通話記錄",
                        "NAME": "姓名",
                        "STORAGE": "貯存",
                        "DURATION": "期間",
                        "ARCHIVES": "視頻通話記錄",
                        "PLAY": "玩",
                        "DELETE": "刪除",
                        "DOWNLOAD_ARCHIVE": {
                            "TITLE": "下載記錄",
                            "GENERATING": "生成下載",
                            "GENERATED": "下載 關聯 生成",
                            "CANNOT_GENERATED": "無法生成下載 關聯。",
                            "DOWNLOAD": "下載",
                            "CLOSE": "關閉"
                        },
                        "DELETE_ARCHIVE": {
                            "TITLE": "刪除記錄",
                            "MESSAGE": "視頻通話記錄將被刪除。",
                            "CAUTION": "注意：此記錄也將從您的 Azure 存儲中刪除。",
                            "CANCEL": "取消",
                            "DELETE": "刪除"
                        }
                    }
                },
                "CONVERTER": {
                    "TITLE": "转换器",
                    "STP_ONLY": "仅支持 .stp 和 .step 文件格式.",
                    "ERROR_UPLOAD": "上传文件时发生错误.",
                    "DRAG": "将您的文件拖放到此处",
                    "OR": "或者",
                    "CHOOSE": "選擇文件",
                    "CONVERT": "兑换",
                    "SUPPORTED": "支持的文件格式：",
                    "BACK": "后退",
                    "DOWNLOAD": "下载",
                    "ERROR_LOAD": "加载对象时发生错误."
                },
                "WHATSNEW": {
                    "WHATSNEW_TITLE": "什麼是新的",
                    "NO_UNREAD_UPDATE": "沒有未讀更新"
                },
                "JOIN_MODAL": {
                    "JOIN" : "加入",
                    "CALL": "通話",
                    "CANCEL": "取消",
                    "MIRROR_VIDEO": "鏡像視頻",
                    "PREFERRED_RESOLUTION": "首選分辨率",
                    "RESOLUTION_NOTE": "注意：如果您的設備不支持您請求的分辨率，將使用下一個最大的分辨率。",
                    "CAM_MIC_PERM_REQUIRED": "需要存取攝像頭和麥克風",
                    "CAM_MIC_PERM_DENIED": "無法存取您的攝像頭或麥克風",
                    "CAM_MIC_CANT_ACCESS": "我們無法存取您的攝像頭或麥克風",
                    "JOIN_CAM_OFF": "加入時將攝像頭設置為關",
                    "JOIN_MIC_OFF": "加入時將麥克風設置為關",
                    "JOIN_CAM_MIC_OFF": "加入時將攝像頭和麥克風設置為關",
                    "JOIN_NO_DEVICE": "無需攝像頭和麥克風即可加入",
                    "ALLOW_ACCESS": "您需要在瀏覽器設置中允許訪問您的攝像頭和麥克風（授予訪問權限後，您仍然可以關閉您的攝像頭或麥克風）。",
                    "TRY_AGAIN": "重試/刷新頁面並在瀏覽器提示時選擇“允許”。"
                },
                "NO_DEVICE_MODAL": {
                    "TITLE": "未找到設備",
                    "JOIN_BODY": "此設備沒有連接麥克風和攝像頭。 其他用戶將無法通過此設備聽到或看到您。 你還想加入嗎？",
                    "CALL_BODY": "此設備沒有連接麥克風和攝像頭。 其他用戶將無法通過此設備聽到或看到您。 你還想打電話嗎？",
                    "CANCEL": "取消",
                    "JOIN": "無論如何加入",
                    "CALL": "無論如何打電話"
                },
                "AGREEMENT_MODAL": {
                    "TITLE": "關於個人數據傳輸的承諾",
                    "REJECTION_BUTTON": "拒絕",
                    "AGREEMENT_BUTTON": "同意"
                },
                "CHECK_AGREEMENT_MODAL": {
                    "TITLE": "取消合同？",
                    "ERROR": "發生錯誤。",
                    "STATEMENT": "當您不接受合同時，您將無法登錄系統。",
                    "CANCEL_BUTTON": "取消",
                    "PROCEED_BUTTON": "繼續"
                },
                "JOIN_UNKNOWN_ERROR" : "加入專室時發生錯誤。",
                "JOIN_CONCURRENT_ERROR" : "您已達到並行用戶限制。 請聯繫您的管理員了解更多詳情。",
                "JOIN_EXPERT_CONCURRENT_ERROR": "您已達到並行專家用戶限制。 請聯繫您的管理員了解更多詳情。",
                "NO_TRAINING_LICENSE": "您的培訓室許可證有問題。 請聯繫您的管理員。",
                "TRAINING_LICENSE_EXPIRED": "您的培訓室許可證已過期。 請聯繫您的管理員。",
                "ASK_TRAINING_HOST": "加入訓練室時發生錯誤。 請聯繫主持人。",
                "JOIN_CALL_IN_PROGRESS": "您的個人會議室中有另一個通話。",
                "NOT_SUPPORTED_TITLE": "不兼容的瀏覽器",
                "NOT_SUPPORTED_MESSAGE": "您的瀏覽器不兼容。 請使用 Google Chrome、Mozilla Firefox、Safari 或 Microsoft Edge（版本 79 或更高版本）。",
                "NO_IOS_MESSAGE": "您的瀏覽器不兼容。 請使用 {{ appName }} Remote 應用或使用 Safari。",
                "IOS_VERSION_MESSAGE": "您的瀏覽器不兼容。 請使用 {{ appName }} Remote 應用程序。",
                "NOT_SUPPORTED_CLOSE": "關閉",
                "IDLE_MODAL_TITLE": "錯誤",
                "IDLE_MODAL_MESSAGE": "你很長一段時間沒有任何交流。",
                "IDLE_MODAL_COUNT": "您將在 {{ count }} 秒後登出。",
                "IDLE_MODAL_OK": "我回來了",
                "ARCHIVE_PERMISSION_MODAL": {
                    "TITLE": "允許錄製嗎？",
                    "MESSAGE": "在這個專室裡的會議將被記錄下來。 您需要允許視頻錄製才能加入此專室。",
                    "DENY": "拒絕",
                    "ALLOW": "允許"
                }
            },
            "ROOM" : {
                "OT_ERROR_MODAL": {
                    "TITLE": "錯誤",
                    "CLOSE": "繼續",
                    "REJOIN": "重新加入",
                    "ENDCALL": "離開",
                    "ERRORS": {
                        "INTERNET": "無法連接會議。 請檢查您的網絡連接。",
                        "TRY_AGAIN": "連接會議時發生錯誤。 請稍後再試。",
                        "UNKNOWN": "連接會議時發生錯誤。",
                        "PUBLISHER_FAILED": "無法與其他參與者共享您的視頻信息流。",
                        "PUBLISHER_CAM_MIC_ACCESS": "確保您的攝像頭和麥克風正常工作並授予攝像頭/麥克風權限。",
                        "SUBSCRIBER_FAILED": "無法連接到參與者視頻信息流之一。"
                    }
                },
                "SIDEBAR" : {
                    "CHAT_TITLE" : "聊天",
                    "PARTICIPANTS_TITLE" : "參與者",
                    "FILES_TITLE" : "文件",
                    "SETTINGS_TITLE" : "設置",
                    "SHOW_TICKET": "顯示工單",
                    "ATTACH_TO_TICKET": "附加到工單",
                    "ATTACH_SESSION_TO_TICKET": "將會議附加到工單",
                    "OPEN_WORKFLOW": "打開工作流程",
                    "CHAT" : {
                        "SEE_TRANSLATION": "查看翻譯",
                        "SEE_ORIGINAL": "查看原文",
                        "TRANSLATING": "正在翻譯",
                        "FILE_SHARE" : {
                            "DRAG_HERE" : "將文件拖到此處",
                            "UPLOAD_TITLE": "上傳文件",
                            "IMAGE": "圖像",
                            "PDF": "PDF",
                            "3D_OBJECT": "3D 對象",
                            "OTHER": "其他",
                            "MULTIPLE_OBJECTS": "我們在您的文件中發現了多個對象。 請一次上傳一個對象（如果存在則帶有紋理）。",
                            "LARGER_THAN": "大於 {{ megabytes }} MB",
                            "FILETYPE_PROHIBITED": "禁止的文件類型",
                            "START_UPLOAD": "上傳",
                            "CANCEL_UPLOAD": "停止",
                            "CLOSE_UPLOAD": "關閉",
                            "CANCEL_MODAL_TITLE": "停止上傳？",
                            "CANCEL_MODAL_MESSAGE": "這將停止當前的上傳。",
                            "CANCEL_MODAL_CLOSE": "取消",
                            "CANCEL_MODAL_CANCEL": "停止"
                        },
                        "DELETE_FILE_MODAL": {
                            "TITLE": "刪除文件？",
                            "MESSAGE": "文件將被刪除",
                            "CLOSE": "關閉",
                            "DELETE": "刪除"
                        },
                        "FILE_DETAILS_MODAL": {
                            "TITLE": "文件詳情",
                            "FILENAME": "文件名稱",
                            "SIZE": "大小",
                            "TYPE": "類型",
                            "UPLOAD_TIME": "上傳時間",
                            "DOWNLOAD": "下載",
                            "CLOSE": "關閉",
                            "FILECOUNT": "總文件數"
                        },
                        "COLLABORATE": "協作",
                        "CLOSE_COLLABORATION": "停止協作",
                        "DOWNLOAD": "下載",
                        "DELETE": "刪除",
                        "DETAILS": "詳情",
                        "SEND_TO_FILES": "發送到文件",
                        "FILE_DELETED": "文件已刪除",
                        "JOIN_ROOM" : "{{ owner_info }} 已加入專室。",
                        "LEAVE_ROOM" : "{{ owner_info }} 已離開專室。",
                        "REACTION": "{{ owner_info }} 發送了一個反應。",
                        "REQUEST_SCREENSHOT": "{{ owner_info }} 已請求快照。",
                        "SHARE_SCREENSHOT" : "{{ owner_info }} 已共享快照。",
                        "SAVED_COLLABORATION": "協作已保存。",
                        "SHARE_IMAGE" : "{{ owner_info }} 共享了一張圖片。",
                        "SHARE_PDF" : "{{ owner_info }} 共享了一個 PDF。",
                        "SHARE_OTHER" : "{{ owner_info }} 共享了一個文件。",
                        "SHARE_OBJECT" : "{{ owner_info }} 共享了一個 3D 對象。",
                        "COLLABORATED" : "{{ owner_info }} 已開始協作。",
                        "TYPE_HERE" : "在此輸入...",
                        "PLEASE_WAIT_OTHERS": "請等待其他用戶加入。",
                        "DOWNLOAD_STARTED_SOON": "下載將很快開始。",
                        "DOWNLOAD_FAILED": "下載失敗。",
                        "DOWNLOAD_OBJECT_NOT_SUPPORTED": "尚不支持對像下載。",
                        "DOWNLOAD_NOT_SUPPORTED": "尚不支持下載。",
                        "CLOSE_PREV_COLLABORATION_TITLE": "關閉當前文件協作？",
                        "CLOSE_COLLABORATION_TITLE": "關閉文件協作？",
                        "CLOSE_PREV_COLLABORATION_MESSAGE": "這將關閉當前文件協作並開始一個新的協作。",
                        "CLOSE_COLLABORATION_MESSAGE": "這將關閉文件協作",
                        "CLOSE_PREV_COLLABORATION_YES": "繼續",
                        "CLOSE_PREV_COLLABORATION_NO": "取消",
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "打開文件協作？",
                            "MESSAGE_AUTHORIZED": "存在固定窗口。 您想取消固定並打開文件協作嗎？",
                            "MESSAGE_UNAUTHORIZED": "無法打開文件協作，因為存在固定窗口。",
                            "CANCEL": "取消",
                            "CLOSE": "關閉",
                            "PROCEED": "繼續"
                        },
                        "CLOSE_ARPLUS_BEFORE_COLL": {
                            "TITLE": "關閉 AR+？",
                            "MESSAGE": "您需要先關閉 AR+，然後才能打開協作。 您確定要關閉 AR+ 嗎？",
                            "NO": "否",
                            "YES": "是"
                        }
                    },
                    "PARTICIPANTS": {
                        "HOST": "（主持人）",
                        "LOWER_ALL_HANDS": "放下所有的手",
                        "RAISED_HAND": "{{ name }} 舉手了。",
                        "DENIED_PUBLISH": "{{ name }} 拒絕加入視頻/音頻通信。",
                        "PARTICIPANT_LIMIT_REACHED": "已達到視頻/音頻通信參與者限制。",
                        "CALLING": "通話：{{參與者}}"
                    },
                    "FILES": {
                        "INFO_TEXT": "所有有權訪問此房間的專家和共同管理員都可以查看和修改此部分中的文件",
                        "DOWNLOAD": "下載",
                        "SEND_TO_SESSION": "發送到會話",
                        "DELETE": "刪除",
                        "UPLOAD_FILE": "上傳文件",
                        "FILE_CONTENTS": "文件內容：",
                        "FILE_NAME": "文件名：",
                        "FILE_SIZE": "文件大小：",
                        "TOTAL_SIZE": "總尺寸：",
                        "DOWNLOAD_STARTED_SOON": "下载将很快开始。",
                        "DOWNLOAD_FAILED": "下载失败。",
                        "DELETE_MODAL": {
                            "TITLE_DELETE": "刪除文件？",
                            "MESSAGE_DELETE": "您確定要刪除此文件嗎？",
                            "CANCEL": "取消",
                            "DELETE": "刪除"
                        }
                    },
                    "SETTINGS": {
                        "MICROPHONE": "麥克風",
                        "CAMERA": "攝像頭",
                        "TRANSLATE_OTHERS_MSG_TO": "將其他信息翻譯為：",
                        "TRANSLATE_MY_MSG_TO": "將我的信息翻譯為：",
                        "CREATE_GUEST_ACCESS": "創建訪客訪問",
                        "GENERATING": "正在生成",
                        "GUEST_ACCESS": "訪客訪問",
                        "COPY_LINK": "複製",
                        "LINK_COPIED": "鏈接已復製到剪貼板。",
                        "LINK_GENERATED": "生成的加入會議鏈接。",
                        "CANNOT_CREATE_GUEST_ACCESS": "無法創建訪客訪問。",
                        "NO_LINK_PERMISSION": "您無權創建訪客訪問鏈接。請聯繫您的管理員。",
                        "SHARE": "分享",
                        "SHARE_LINK_VIA_SMS": "通過短信分享鏈接",
                        "SMS_SEND": "通過短信發送鏈接",
                        "OPENING": "開幕",
                        "SEND": "發送",
                        "SMS_LIMIT_REACHED": "已達到短信發送限制。請聯繫您的管理員。",
                        "ERROR_OCCURED": "發生錯誤。",
                        "SMS_LICENSE_PERMISSION": "您沒有發送短信的權限。請聯繫您的管理員。",
                        "RESHARE": "您可以在一分鐘內分享一次鏈接。",
                        "DIDNT_GET": "沒收到鏈接？",
                        "PHONE_NUMBERS": "最近使用的電話號碼",
                        "RESEND": "重發。",
                        "CANCEL": "取消",
                        "CONNECT_VIA_FIELD_CODE": "通過 Field ID 與用戶聯繫",
                        "CONNECT": "連接",
                        "INVITATION_SENT": "邀請已發送給用戶。",
                        "INVITATION_COULD_NOT_SENT": "無法將邀請發送給用戶。",
                        "FIELD_CODE": "Field ID"
                    }
                },
                "VIDEO_CHAT" : {
                    "AUDIO_BITRATE": "音頻比特率",
                    "AUDIO_PACKET_LOSS": "音頻丟包",
                    "VIDEO_BITRATE": "視頻比特率",
                    "VIDEO_PACKET_LOSS": "視頻丟包",
                    "RESOLUTION": "解析度",
                    "WAIT_OTHER_USERS" : "請等待其他用戶加入。",
                    "WAIT_EXPERT": "請等待專家加入。",
                    "WAIT_MASTER": "請等待主持人開始會議。",
                    "START_SESSION": "開始會議",
                    "HOST_WITHDRAW_REQUEST": "主機撤回視頻/音頻請求。",
                    "NO_CAM_MIC": "您的攝像頭和麥克風不可用。",
                    "NO_CAM": "您的相機不可用。",
                    "NO_MIC": "您的麥克風不可用。",
                    "JOIN_VIDEO_AUDIO_MODAL": {
                        "TITLE": "加入視頻/音頻通信？",
                        "MESSAGE": "主持人希望您啟用視頻/音頻。",
                        "DENY": "拒絕",
                        "ACCEPT": "接受"
                    },
                    "PUBLISHER" : {
                        "YOU": "您",
                        "SCREEN_SHARE_MESSAGE": "您正在共享您的屏幕",
                        "STOP_SCREEN_SHARING": "停止共享"
                    },
                    "SUBSCRIBER" : {
                        "APP_NOT_UP_TO_DATE_FOR_STATS": "無法顯示網絡狀態，因為該參與者的應用程序不是最新的。",
                        "SNAPSHOT": "快照",
                        "AR_PLUS": "AR 協作",
                        "SCREENSHOT_REQUESTED": "快照已請求",
                        "VIDEO_NOT_AVAILABLE": "視頻不可用",
                        "WEAK_SIGNAL": "信號微弱",
                        "AUDIO_ONLY_MODE": "純音頻模式",
                        "FLASH": "閃光燈",
                        "AR_NOT_AVAILABLE": "AR 不適用於此設備。",
                        "CHARGING": "正在充電",
                        "LOW_BATTERY": "低電量",
                        "CLOSE_AR_PLUS_MODAL": {
                            "TITLE": "關閉 AR+？",
                            "MESSAGE": "確定要關閉 AR+ 嗎？",
                            "NO": "否",
                            "YES": "是"
                        },
                        "DISABLE_FOCUS_MODAL": {
                            "TITLE": "打開 AR+？",
                            "MESSAGE_AUTHORIZED": "存在固定窗口。 您要取消固定並打開 AR+ 嗎？",
                            "MESSAGE_UNAUTHORIZED": "AR+ 無法打開，因為存在固定窗口。",
                            "CANCEL": "取消",
                            "CLOSE": "關閉",
                            "PROCEED": "繼續"
                        },
                        "REFRESH_SURFACES": "刷新曲面",
                        "AR_PLUS_LOCKED": "AR+ 已鎖定。 請先解鎖AR+。"
                    },
                    "CONTROL_BAR": {
                        "SHARE_SCREEN": "共享屏幕",
                        "STOP_SHARE": "停止共享",
                        "MIC_OFF": "麥克風",
                        "CAM_OFF": "攝像頭",
                        "CAM_MIC_CANT_ACCESS": "我們無法訪問您的攝像頭或麥克風",
                        "LEAVE_CALL": "離開",
                        "LEAVE_SESSION": "離開會話",
                        "LEAVE_MEETING": "離開會議",
                        "END_SESSION_FOR_ALL": "為所有人結束會議",
                        "END_MEETING_FOR_ALL": "結束全體會議",
                        "ENDCALL_MODAL": {
                            "TITLE_LEAVE": "離開會話？",
                            "TITLE_LEAVE_MEETING": "離開會議？",
                            "TITLE_END_ALL": "為所有人結束會議？",
                            "TITLE_END_ALL_MEETING": "結束所有人的會議？",
                            "MESSAGE_LEAVE": "您確定要離開會話嗎？",
                            "MESSAGE_END_ALL": "您確定要結束會話嗎？",
                            "MESSAGE_LEAVE_MEETING": "您確定要離開會議嗎？",
                            "MESSAGE_END_ALL_MEETING": "您確定要結束會議嗎？",
                            "CANCEL": "取消",
                            "END": "結束",
                            "LEAVE": "離開",
                            "REMOVE_MEETING_LINK": "同時禁用並刪除會議鏈接"
                        },
                        "RAISE_HAND": "舉手",
                        "LOWER_HAND": "下手",
                        "RECORD": "錄製",
                        "AUTO_RECORD": "自動錄製",
                        "STOP_RECORD": "停止錄製",
                        "CANCEL": "取消請求",
                        "ASK_ARCHIVE_PERMISSION": "請求錄製許可",
                        "REACTION": "反應",
                        "EXTENSION_MODAL_TITLE": "需要擴展組件",
                        "EXTENSION_MODAL_MESSAGE": "Google Chrome 需要擴展屏幕共享功能。 請安裝擴展組件或使用 Mozilla Firefox",
                        "EXTENSION_MODAL_NO": "取消",
                        "EXTENSION_MODAL_YES": "打開擴展組件頁面",
                        "ARCHIVE_NO_PERMISSION": "您沒有權限錄製此會議。 請聯繫您的管理員。",
                        "P2P_NO_ARCHIVE": "對等視頻通話無法錄製。 請聯繫您的管理員。",
                        "SCREEN_SHARE_UPDATE": "您當前的瀏覽器版本不支持屏幕共享。 請更新您的瀏覽器。",
                        "SCREEN_SHARE_NOT_SUPPORTED": "您的瀏覽器不支持屏幕共享。",
                        "SCREEN_SHARE_USE_OTHER": "您的瀏覽器不支持屏幕共享。 請使用 Google Chrome 或 Mozilla Firefox。",
                        "SCREEN_SHARE_FAILED": "無法共享屏幕。",
                        "ARCHIVE_REQUESTED": "視頻錄製將開始。 需要您的許可。",
                        "ARCHIVE_REQUESTED_WITH_NAME": "{{ name }} 想開始視頻錄製。 需要您的許可。",
                        "DENY": "拒絕",
                        "ALLOW": "允許"
                    },
                    "PDF_COLLABORATION": {
                        "PREVIOUS_PAGE": "上一頁",
                        "NEXT_PAGE": "下一頁"
                    },
                    "COLLABORATION_SHARED": {
                        "SOME_USERS_CANNOT_LOAD": "某些用戶無法加載文件協作。",
                        "DOWNLOAD_FAILED": "無法下載文件協作。",
                        "END_COLL_TITLE": "關閉文件協作？",
                        "END_COLL_MESSAGE": "這將關閉文件協作。",
                        "END_COLL_NO": "取消",
                        "END_COLL_YES": "繼續",
                        "ALREADY_ENDED": "文件協作已結束。",
                        "CANNOT_END_COLLABORATION": "無法結束文件協作。",
                        "ANNOTATE": "註釋",
                        "FULLSCREEN": "全屏",
                        "DOWNLOAD_COLLABORATION": "下載協作",
                        "SNAPSHOT_COLLABORATION": "快照協作",
                        "UNDO": "復原",
                        "REDO": "反做",
                        "REVERT": "恢復",
                        "RELOAD": "重新加載"
                    },
                    "TRY_TO_FOCUS_MODAL": {
                        "TITLE": "固定窗口？",
                        "MESSAGE": "在 AR+ 模式下無法固定。 關閉 AR+ 並固定？",
                        "CANCEL": "取消",
                        "PROCEED": "繼續"
                    }
                }
            },
            "RECONNECT_ROOM": {
                "RECONNECT_MESSAGE": "看起來好像出錯了。我們正在努力恢復您的通話。"
            },
            "SESSION_RATING": {
                "BAD": "壞的",
                "POOR": "不足",
                "FAIR": "平均數",
                "GOOD": "好的",
                "EXCELLENT": "優秀",
                "RATING_MESSAGE" : "會議質量如何？",
                "REVIEW_MESSAGE" : "告訴我們原因（可選）",
                "SUCCESS_MESSAGE": "感謝您對會議進行評分。",
                "CLOSE": "關閉",
                "SUBMIT": "提交",
                "DISMISS": "拒絕"
            },
            "PRECALL_TEST": {
                "BACK_TO_LOBBY": "回到大堂",
                "RUN_PRECALL_TEST": "運行預通話測試",
                "WHAT_TEST": {
                    "TITLE": "我們要準備測試",
                    "CONNECTIVITY": "與所有媒體服務器的連接。",
                    "STATS": "收集比特率和丟包統計信息。",
                    "SETUP": "端點上的硬件和軟件設置（攝像頭、麥克風、瀏覽器）。"
                },
                "BEFORE_START": {
                    "TITLE": "在你開始之前",
                    "MAKE_SURE": "確保;",
                    "RIGHT_NETWORK": "您位於要測試的特定網絡上。",
                    "TCP_PORT_OPEN": "您至少打開了 TCP 端口 443。",
                    "RIGHT_HARDWARE": "選擇了正確的攝像頭和麥克風。",
                    "BANDWITH": "帶寬超過350kbps上傳和下載。"
                },
                "HARDWARE_SOFTWARE": {
                    "TITLE": "硬件/軟件設置",
                    "OPERATING_SYSTEM": {
                        "MESSAGE": "操作系統",
                        "BETTER_ALTERNATIVE_IOS": "您可以從 AppStore 下載 {{ appName }} Remote App 以獲得更好的體驗。",
                        "BETTER_ALTERNATIVE_ANDROID": "您可以從 Google Play 商店下載 {{ appName }} Remote App 以獲得更好的體驗。"
                    },
                    "BROWSER": {
                        "MESSAGE": "瀏覽器",
                        "NOT_SUPPORTED": "不支持您的瀏覽器。 請使用 Google Chrome、Mozilla Firefox、Safari 或 Microsoft Edge（版本 79 或更高版本）。",
                        "NOT_COMPATIBLE": "您的瀏覽器不兼容。 請更新您的瀏覽器。",
                        "USE_SAFARI": "您的瀏覽器不兼容。 請使用 {{ appName }} Remote 應用程序或使用 Safari。"
                    },
                    "HARDWARE": {
                        "MESSAGE": "攝像頭/麥克風存取",
                        "CANT_ACCESS": "我們無法存取您的攝像頭/麥克風。"
                    }
                },
                "CONNECTION_SERVERS": {
                    "TITLE": "連接到我們的服務器",
                    "INTERNET": {
                        "MESSAGE": "網絡連接",
                        "OFFLINE": "您的網絡連接似乎處於離線狀態。"
                    },
                    "SERVERS": {
                        "MESSAGE": "連接到我們的服務器",
                        "UNKNOWN_ERROR_TRY": "連接到服務器時發生錯誤。 請稍後再試。",
                        "UNKNOWN_ERROR": "連接到服務器時發生錯誤。"
                    }
                },
                "QUALITY": {
                    "TITLE": "“音頻/視頻質量",
                    "AUDIO_VIDEO": {
                        "MESSAGE": "音頻/視頻質量",
                        "UNKNOWN_ERROR": "測試音頻/視頻質量時發生錯誤。",
                        "VIDEO": "視頻",
                        "VIDEO_QUALITY": "視頻質量： ",
                        "VIDEO_PACKET_LOSS": "數據包丟失： ",
                        "VIDEO_BITRATE": "視頻比特率： ",
                        "AUDIO": "音頻",
                        "AUDIO_QUALITY": "音頻質量： ",
                        "AUDIO_PACKET_LOSS": "數據包丟失： ",
                        "AUDIO_BITRATE": "音頻比特率： ",
                        "QUALITY_EXCELLENT": "（優良）",
                        "QUALITY_GOOD": "（良好）",
                        "QUALITY_BAD": "（不良）"
                    }
                },
                "STOP_TEST_MODAL": {
                    "TITLE": "停止測試？",
                    "MESSAGE": "這將停止預通話測試。",
                    "NO": "取消",
                    "YES": "停止"
                }
            },
            "EMAIL_RECIPIENTS": {
                "PLACEHOLDER": "添新",
                "SECONDARY_PLACEHOLDER": "请输入电邮地址",
                "INVALID_EMAIL": "电子邮件格式无效。"
            },
            "WORKFLOW_REMOTE": {
                "ERRORS": {
                    "INTEGRATION_ALREADY_USED": "集成已使用",
                    "MISSING_PARAMETERS": "缺少參數",
                    "CALL_IN_PROGRESS": "通話正在進行中",
                    "USER_IN_ANOTHER_ROOM": "另一個房間的用戶"
                }
            }
        },
        "HELP_CENTER": {
            "TITLE": "{{ appName }} 服務台",
            "TITLE_WITH_REMOTE": "{{ appName }} Remote 服務台",
            "FAILED": "發生錯誤。"
        },
        "EXTERNALS": {
            "JOIN_WITH_LINK": {
                "TITLE": "{{ appName }} Remote 訪客訪問",
                "SESSION_NOT_FOUND": "找不到您請求的會議。",
                "SESSION_NOT_AVAILABLE": "此會議已不再可用。",
                "CONCURRENT_LIMIT_REACHED": "已達到並行用戶限制。 請聯繫您的管理員。",
                "EXPERT_CONCURRENT_LIMIT_REACHED": "已達到並行專家用戶限制。 請聯繫您的管理員。",
                "UNKNOWN_ERROR": "哎呀！出事了！",
                "ABOUT_TO_JOIN": "你即將加入 ",
                "ENTER_NAME": "輸入你的名稱",
                "NAME_REQUIRED": "名稱是必需的",
                "NAME_SHORT": "名稱必須至少為 2 個字符",
                "JOIN": "加入",
                "CONTINUE_TO_WEBSITE": "通过浏览器继续"
            },
            "ARCHIVE_LIST": {
                "TITLE": "視頻通話記錄",
                "LOADING": "加載中",
                "LOAD_FAILED": "發生錯誤。",
                "CREATED_AT": "創建於",
                "SIZE": "大小",
                "STATUS": "狀態",
                "DOWNLOAD": "下載",
                "GENERATING": "生成鏈接",
                "CLICK_TO_DOWNLOAD": "點擊下載",
                "AVAILABLE": "可用",
                "DISCONNECTED": "已中斷",
                "DELETED": "已刪除",
                "EXPIRED": "已到期",
                "WAITING": "等待中",
                "FAILED": "已失敗"
            },
            "AUTHENTICATE": {
                "MESSAGE": "發生錯誤。"
            },
            "AD_LOGIN": {
                "MESSAGE": "發生錯誤。"
            },
            "AD_ERROR": {
                "ACCOUNT_NOT_FOUND": "你的帳戶未連接到 Azure AD。",
                "PERMISSION_DENIED": "您無權查看此頁面。",
                "INTERNAL_ERROR": "發生錯誤。",
                "CONTACT_MAIL": "請聯繫<strong>{{ contactMail }}</strong>"
            }
        },
        "TUTORIALS": {
            "TUTORIAL_LINK": "顯示用戶教程",
            "NEXT": "下一個",
            "END": "結束",
            "MIC_CAMERA": "打開/關閉麥克風或攝像頭",
            "END_CALL": "離開會話",
            "RECORD": "開始/停止所有會議的錄製",
            "SCREEN_SHARING": "開始/停止屏幕共享以向其他用戶展示您的操作",
            "REACTION": "給大家發個反應，語音交流不夠用的時候有用",
            "OPEN_AR_PLUS": "打開 AR+",
            "DRAW_ON_SURFACE": "使用 AR+ 在實時流中以藍色網格突出顯示的表面上繪圖",
            "OPEN_AR": "打開 AR",
            "HOLD_TO_HIGHLIGHT": "單擊並按住任意位置以使用 AR 突出顯示實時信息流中的特定區域",
            "TAKE_SNAPSHOT": "從其他用戶那裡拍攝高質量的快照",
            "NO_CAMERA": "其他參與者的攝像頭必須打開",
            "WAIT_OR_SKIP": "等待其他用戶或跳過此功能",
            "COLLABORATE": "協作處理快照：草圖、放置圖表、特殊形狀、文本",
            "OPEN_ANNOTATION": "打開註釋",
            "SKETCH_ON_COLL": "在協作窗格上繪製草圖",
            "END_TUTORIAL": "您可以隨時從這裡訪問本教程",
            "USER_TUTORIAL": "用戶教程",
            "GUIDE": "本用戶教程將指導您逐步完成平台",
            "DONT_SHOW": "不再顯示",
            "SKIP_TUTORIAL": "跳過教程",
            "CANCEL": "取消",
            "SKIP": "跳過",
            "ASK_AGAIN": "您確定要跳過本教程嗎？"
        },
        "NOT_FOUND": {
            "PAGE_NOT_FOUND": "很抱歉，無法找到您請求的頁面。",
            "NO_LONGER_AVAILABLE": "URL 可能拼寫錯誤或您要查找的頁面不再可用。"
        },
        "DOWNLOADS": {
            "FILE_NOT_FOUND": "文件未找到",
            "IF_DOWNLOAD_NOT_STARTED": "如果尚未開始下載，",
            "CLICK_HERE": "請單擊此處"
        },
    "PAGINATOR": {
        "ITEMS_PER_PAGE": "每頁項數:",
        "NEXT_PAGE": "下一頁",
        "PREVIOUS_PAGE": "上一頁",
        "FIRST_PAGE": "第一頁",
        "LAST_PAGE": "最後一頁",
        "RANGE": "第 {{start}} – {{end}} 項，共 {{length}} 項",
        "RANGE_ZERO": "共 {{length}} 項"
    }
}